module.exports = __webpack_public_path__ + "img/sea.c6180a22.svg";